import { createSlice, type PayloadAction } from '@ufc/core'

import type { LiveTripsResponse } from '../domain/types/api.types'
import type { DriverMilestone } from '../domain/types/api.types'

export interface TripPlanningLiveState {
  result: LiveTripsResponse | null
  loading: boolean
  error: string | null
  arrivingReference: string | null
}

const initialState: TripPlanningLiveState = {
  result: null,
  loading: false,
  error: null,
  arrivingReference: null,
}

const slice = createSlice({
  name: 'tripPlanningLive',
  initialState,
  reducers: {
    load: (state, _action: PayloadAction<string>) => {
      state.loading = true
      state.error = null
    },
    loadSuccess: (state, action: PayloadAction<LiveTripsResponse>) => {
      state.result = action.payload
      state.loading = false
    },
    loadFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
    confirmArrival: (state, action: PayloadAction<{ referenceId: string; planDate: string }>) => {
      state.arrivingReference = action.payload.referenceId
      state.error = null
    },
    confirmArrivalSuccess: (state) => {
      state.arrivingReference = null
    },
    confirmArrivalFailure: (state, action: PayloadAction<string>) => {
      state.arrivingReference = null
      state.error = action.payload
    },
    confirmMilestone: (state, action: PayloadAction<{ referenceId: string; planDate: string; milestone: DriverMilestone }>) => {
      state.arrivingReference = action.payload.referenceId
      state.error = null
    },
    confirmMilestoneSuccess: (state) => {
      state.arrivingReference = null
    },
    confirmMilestoneFailure: (state, action: PayloadAction<string>) => {
      state.arrivingReference = null
      state.error = action.payload
    },
  },
})

export const tripPlanningLiveActions = slice.actions
export const tripPlanningLiveReducer = slice.reducer
